<template>
  <el-table-column :prop="col.prop"
                   :label="col.label"
                   align="left"
                   min-width="200"
                   show-overflow-tooltip
  >
    <template slot-scope="scope">
      <slot :name="col.prop"
            :row="scope.row"
            :index="scope.$index">
        {{ scope.row[col.prop] }}
      </slot>
    </template>

    <template v-if="col.children">
      <ucp-table-col v-for="(item, index) in col.children"
                 :key="index"
                 :col="item">
      </ucp-table-col>
    </template>
  </el-table-column>
</template>

<script>
  export default {
    name: 'ucp-table-col',
    props: ['col'],
    data (){
      return {

      }
    },
    methods: {

    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/util/ucp-table-col.vue